<div class="prefix-wrapper">
  <ng-content select="[prefix]" />
</div>

<input
  #input
  [type]="type()"
  [disabled]="disabled"
  [attr.readOnly]="readOnly() ? '' : null"
  [attr.autocomplete]="autocompleteName() || null"
  [placeholder]="placeholder() || ''"
  [attr.maxlength]="maxLength()"
  [attr.tabindex]="tabIndex()"
  [style.width]="width()"
  (input)="handleChange($any($event.target).value)"
  (focus)="focus.emit($event)"
  (blur)="blur.emit($event)"
  [attr.data-form-type]="preventAutocompleteSuggestions() ? 'other' : null"
  [attr.data-lpignore]="preventAutocompleteSuggestions()"
  [attr.data-1p-ignore]="preventAutocompleteSuggestions() || null"
  [attr.data-bwignore]="preventAutocompleteSuggestions() || null"
/>

<div class="suffix-wrapper">
  @if (loading()) {
    <rt-spinner variant="small" />
  }
  @if (hasDropdownIndicator()) {
    <rt-icon (click)="setFocus()" name="arrow-drop-down" class="dropdown-indicator" />
  }
  @if (isRemoveButtonVisible()) {
    <rt-icon-button
      #clearButton
      (click)="onRemoveButtonClick($event)"
      variant="plain"
      iconName="close"
      shape="square"
      size="small"
    />
  }
  <ng-content select="[suffix]" />
</div>
